import React from 'react';
import { Icon } from 'semantic-ui-react';

const ProcessingStatusHint = ({
  selectedStory,
  title,
  thumbnail,
  pdfFile,
  isProcessing
}) => {
  const steps = [
    {
      key: 'story',
      label: 'Select Story',
      completed: !!selectedStory,
      current: !selectedStory
    },
    {
      key: 'title',
      label: 'Enter Title',
      completed: !!title && title.trim() !== '',
      current: !!selectedStory && (!title || title.trim() === '')
    },
    {
      key: 'cover',
      label: 'Select Cover',
      completed: !!thumbnail,
      current: !!selectedStory && !!title && title.trim() !== '' && !thumbnail
    },
    {
      key: 'pdf',
      label: 'Select PDF',
      completed: !!pdfFile,
      current: !!selectedStory && !!title && title.trim() !== '' && !!thumbnail && !pdfFile
    },
    {
      key: 'submit',
      label: 'Submit',
      completed: isProcessing,
      current: !!selectedStory && !!title && title.trim() !== '' && !!thumbnail && !!pdfFile && !isProcessing
    }
  ];

  const getStepClass = (step) => {
    if (step.completed) return 'processing-step completed';
    if (step.current) return 'processing-step current';
    return 'processing-step pending';
  };

  return (
    <div className="processing-status-hint">
      <div className="processing-steps">
        {steps.map((step, index) => (
          <React.Fragment key={step.key}>
            <div className={getStepClass(step)}>
              <span className="step-number">{index + 1}</span>
              <span className="step-label">{step.label}</span>
              {step.completed && <Icon name="check" className="step-check" />}
            </div>
            {index < steps.length - 1 && (
              <Icon name="arrow right" className="step-arrow" />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ProcessingStatusHint;
